import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import PlusSm from '@/assets/icons/plus-sm.svg';
import { Button } from '@/components/ui/button';

/** Matches date range picker Apply (`Button` default / primary gradient). */
export const BANNER_ACTION_BUTTON_CLASSNAME = 'shrink-0 whitespace-nowrap';

type CreateHiringGoalButtonProps = {
  hiringGoalUrl: string;
  variant?: 'default' | 'secondary';
};

export function CreateHiringGoalButton({
  hiringGoalUrl,
  variant = 'default',
}: CreateHiringGoalButtonProps) {
  const isPrimary = variant === 'default';

  return (
    <Button
      className={BANNER_ACTION_BUTTON_CLASSNAME}
      variant={variant}
      asChild
    >
      <Link
        to={hiringGoalUrl}
        target="_blank"
        className={isPrimary ? 'text-white hover:text-white' : undefined}
      >
        {isPrimary && (
          <img
            src={PlusSm}
            alt=""
            aria-hidden="true"
            className="brightness-0 invert"
          />
        )}
        <FormattedMessage
          defaultMessage="Create new hiring goal"
          description="Banner CTA: open Hire to create a new hiring goal"
        />
      </Link>
    </Button>
  );
}
